import { useEffect, useCallback } from 'react'
import { useWebSocket } from './WebSocketProvider'
import { NODE_EVENTS } from './constants'

const useNodeEvents = (options = {}) => {
  const { subscribe } = useWebSocket()

  const {
    onCreated,
    onUpdated,
    nodeId,
  } = options

  const matchesFilter = useCallback((node) => {
    if (nodeId && node.id !== nodeId) return false
    return true
  }, [nodeId])

  const createHandler = useCallback((handler) => {
    if (!handler) return null
    return (node) => {
      if (matchesFilter(node)) {
        handler(node)
      }
    }
  }, [matchesFilter])

  useEffect(() => {
    const unsubscribers = []

    if (onCreated) {
      const handler = createHandler(onCreated)
      if (handler) {
        unsubscribers.push(subscribe(NODE_EVENTS.CREATED, handler))
      }
    }

    if (onUpdated) {
      const handler = createHandler(onUpdated)
      if (handler) {
        unsubscribers.push(subscribe(NODE_EVENTS.UPDATED, handler))
      }
    }

    return () => {
      unsubscribers.forEach((unsubscribe) => unsubscribe())
    }
  }, [subscribe, createHandler, onCreated, onUpdated])
}

export default useNodeEvents
